<template>
    <div class="purpose-section">
        <div class="section-header">
            <h2>あなたの目的に合ったサービスをご用意</h2>
            <p class="hide-sp">あなたにとっての理想のキャリアを実現するサービスを選びましょう</p>
        </div>
        <ul class="purpose-list">
            <li class="purpose-item purpose-item01">
                <div class="purpose-item-inner">
                    <div class="purpose-item-btn">
                        <span class="hide-sp">
                            将来性のあるスキルを身に着け
                            <br>
                            手に職をつけたい
                        </span>
                        <span class="hide-pc">
                            将来性のあるスキルで手に職をつけたい
                        </span>
                    </div>
                </div>
            </li>
            <li class="purpose-item purpose-item02">
                <div class="purpose-item-inner">
                    <div class="purpose-item-btn">
                        <span class="hide-sp">
                            時間や場所に縛られない
                            <br>
                            自由な働き方をしたい
                        </span>
                        <span class="hide-pc">
                            時間や場所に縛られず自由に働きたい
                        </span>
                    </div>
                </div>
            </li>
            <li class="purpose-item purpose-item03">
                <div class="purpose-item-inner">
                    <div class="purpose-item-btn">
                        <span class="hide-sp">
                            フリーランスや副業など
                            <br>
                            個人で稼げる人材になりたい
                        </span>
                        <span class="hide-pc">
                            フリーランスや副業で稼げるようになりたい
                        </span>
                    </div>
                </div>
            </li>
            <li class="purpose-item purpose-item04">
                <div class="purpose-item-inner">
                    <div class="purpose-item-btn">
                        <span class="hide-sp">
                            テクノロジー業界で
                            <br>
                            クリエイティブな仕事がしたい
                        </span>
                        <span class="hide-pc">
                            IT業界でクリエイティブな仕事がしたい
                        </span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Purpose'
}
</script>

<style scoped>

    .purpose-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        /* padding: 0 100px; */
        width: 80%;
        margin: 0 auto;
    }

    .purpose-list .purpose-item {
        width: 40%;
        height: 360px;
        padding:0 20px;
        margin-bottom: 4%;
    }

    .purpose-item01 .purpose-item-inner{
        background-image: url(../assets/purpose_01-2d4ce4a0f498412de61c903bae3f1337.jpg);
    }

    .purpose-item02 .purpose-item-inner{
        background-image: url(../assets/purpose_02-f2cd99cda192695858eed1d09b8ee8c5.jpg);
    }

    .purpose-item03 .purpose-item-inner{
        background-image: url(../assets/purpose_03-556abd9fe8d8e1a902731c815dba1073.jpg);
    }

    .purpose-item04 .purpose-item-inner{
        background-image: url(../assets/purpose_04-46e24bd8d149d615a2cce1cf22d482db.jpg);
    }

    .purpose-item-btn {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 20px 50px;
        line-height: 28px;
        background-color: rgba(255,255,255,0.95);
        font-size: 1.3rem;
        text-align: center;
    }

    .purpose-item-inner {
        display: block;
        position: relative;
        width: 100%;
        height: 100%;
        background-position: center;
        background-size: cover;
        border-radius: 10px;
        box-shadow: 0 0 12px rgba(0,0,0,0.05);
        overflow: hidden;
    }

    ul {
        list-style: none;
    }

    @media screen and (max-width: 767px) {
        .purpose-list .purpose-item {
            height: 200px;
        }

        .purpose-item-btn {
            padding: 15px 20px 15px 10px;
            line-height: 1.2;
            font-size: .8rem;
            text-align: left;
        }
    }
</style>